export const FETCHED = 'USER_FETCHED'
export const LOCATION_FETCHED = 'LOCATION_FETCHED'
export const LOGOUT = 'USER_LOGOUT'
export const FETCHED_IS_REGISTERED_FOR_ONRAMP =
  'FETCHED_IS_REGISTERED_FOR_ONRAMP'
